// extracted by mini-css-extract-plugin
export default {"detailsContainer":"LoanDetails_detailsContainer__UF6K+","fieldTitle":"LoanDetails_fieldTitle__RwE6Y","details":"LoanDetails_details__zj0Ba"};